 
class ProductZoom {
  constructor() {
    this.init();
  }
 
  init() {
    const mediaItems = document.querySelectorAll('.product-gallery__media');
    
    mediaItems.forEach(media => {
      const img = media.querySelector('img');
      if (img) {
        media.classList.add('zoom-enabled');
        this.setupZoom(media, img);
      }
    });
  }

  setupZoom(container, img) {
    let isZoomed = false;

    container.addEventListener('mousemove', (e) => {
      if (!isZoomed) return;

      const bounds = container.getBoundingClientRect();
      const x = e.clientX - bounds.left;
      const y = e.clientY - bounds.top;
      
      const xPercent = x / bounds.width * 100;
      const yPercent = y / bounds.height * 100;

      img.style.transformOrigin = `${xPercent}% ${yPercent}%`;
    });

    container.addEventListener('mouseenter', () => {
      isZoomed = true;
      img.style.transform = 'scale(1.5)'; // Adjust zoom level here
    });

    container.addEventListener('mouseleave', () => {
      isZoomed = false;
      img.style.transform = 'scale(1)';
    });
  }
}

// Initialize zoom functionality
document.addEventListener('DOMContentLoaded', () => {
  new ProductZoom();
});
 